<template>
    <v-dialog v-model="show" persistent max-width="750px">
        <v-card rounded="lg">
            <v-card-title class="primary--text">
                <span>View Details</span>
                <v-icon class="ml-auto" @click="show = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="4">
                        <span class="primary--text font-weight-bold text-caption">
                            Name
                        </span>
                        <p class="font-weight-bold">
                            {{ details.name }}
                        </p>
                    </v-col>
                    <v-col cols="4">
                        <span class="primary--text font-weight-bold text-caption">
                            Specialization
                        </span>
                        <p>
                            {{ details.specialization }}
                        </p>
                    </v-col>
                    <v-col cols="4">
                        <span class="primary--text font-weight-bold text-caption">
                            Availability
                        </span>
                        <p>
                            {{ details.availability }}
                        </p>
                    </v-col>
                </v-row>
                <!-- <v-row>
                    <v-col cols="4">
                        <span class="primary--text font-weight-bold text-caption">
                            Assigned OB calls
                        </span>
                        <div>
                            <v-list  v-if="details.calls && details.calls.length">
                                <v-list-item
                                    v-for="(call, index) in details.calls"
                                    :key="index"
                                >
                                    <v-list-item-title>{{ call.patient.patient.full_name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ call.health_concern }}</v-list-item-subtitle>
                                    <v-list-item-action>
                                        <v-icon
                                            color="error"
                                            @click="removeCaseToDoctor(index)"
                                        >
                                            mdi-delete-outline
                                        </v-icon>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                            <p v-else>
                                No OB calls yet
                            </p>
                        </div>
                       
                    </v-col>
                </v-row> -->
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        // show: {
        //     type: Boolean,
        //     default: false
        // },
        details: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data: () => ({
        show: false
    }),
    methods: {
        removeCaseToDoctor(index) {
            console.log({ index })
        }
    }
}
</script>